type Permission = 'PERMISS' | 'UNPERMISS'

interface TreatmentPlanPermissionInput {
  user?: { hasTreatmentPlan?: unknown, hasCreateTreatmentPlan?: unknown, hasEditTreatmentPlan?: unknown, hasDeleteTreatmentPlan?: unknown }
  createPermission?: Permission
  editPermission?: Permission
  deletePermission?: Permission
  readOnly?: boolean
}

export function getTreatmentPlanPermissions({
  user,
  createPermission,
  editPermission,
  deletePermission,
  readOnly = false,
}: TreatmentPlanPermissionInput) {
  // A screen can restrict a user's permission, but cannot grant it.
  const canCreate = !readOnly && user?.hasCreateTreatmentPlan === 'PERMISS' && createPermission !== 'UNPERMISS'
  const hasEditGrant = user?.hasEditTreatmentPlan === 'PERMISS'
  return {
    canView: user?.hasTreatmentPlan === 'PERMISS',
    canCreate,
    canEdit: !readOnly && hasEditGrant && editPermission !== 'UNPERMISS',
    canDelete: !readOnly && user?.hasDeleteTreatmentPlan === 'PERMISS' && deletePermission !== 'UNPERMISS',
  }
}
